import {I18n} from '@aws-amplify/core';
import {Badge, Text} from '@mantine/core';

import {BillableUnitStatus} from '../types';

const colors: Record<BillableUnitStatus, string> = {
    [BillableUnitStatus.DRAFT]: 'yellow',
    [BillableUnitStatus.ACTIVE]: 'green',
    [BillableUnitStatus.RETIRED]: 'gray',
};

// The badge text carries the status; colour only reinforces it (§13).
export const BillableUnitStatusBadge = ({status}: { status?: BillableUnitStatus | null }) => {
    if (!status) {
        return <Text size='sm'>—</Text>;
    }
    return <Badge color={colors[status]} variant='light'>{I18n.get(status)}</Badge>;
};
